import React, { useState, useEffect } from 'react';
import { contentService } from '../../services/adminService';
import './ContentManager.css';

function ContentManager({ apiBase, roleColor }) {
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadContents();
  }, [filterStatus]);

  const loadContents = async () => {
    setLoading(true);
    try {
      const response = await contentService.listContents({
        status_id: filterStatus || undefined,
        search: searchTerm || undefined,
        limit: 50
      });
      if (response.ok && response.data) {
        setContents(response.data.contents || []);
      }
    } catch (err) {
      console.error('Error loading contents:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Hapus konten ini?')) {
      try {
        await contentService.deleteContent(id);
        loadContents();
      } catch (err) {
        console.error('Error deleting:', err);
      }
    }
  };

  return (
    <div className="content-manager">
      <div className="manager-header">
        <h2>Ubah Konten</h2>
        <button className="btn-primary" style={{ background: roleColor }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Konten Baru
        </button>
      </div>

      <div className="manager-filters">
        <input
          type="text"
          placeholder="Cari konten..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="filter-input"
        />
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className="filter-select"
        >
          <option value="">Semua Status</option>
          <option value="1">Draft</option>
          <option value="2">Submitted</option>
          <option value="3">Approved</option>
          <option value="5">Published</option>
        </select>
        <button onClick={loadContents} className="btn-search">
          Cari
        </button>
      </div>

      {loading ? (
        <div className="loading-state">
          <svg className="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" />
          </svg>
          <p>Memuat konten...</p>
        </div>
      ) : contents.length === 0 ? (
        <div className="empty-state">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          <p>Tidak ada konten</p>
        </div>
      ) : (
        <div className="content-list">
          {contents.map(content => (
            <div key={content.id} className="content-item">
              <div className="item-info">
                <h4>{content.title}</h4>
                <p className="item-slug">{content.slug}</p>
                <div className="item-meta">
                  <span className="meta-item">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    {new Date(content.created_at).toLocaleDateString('id-ID')}
                  </span>
                  <span className={`status-badge status-${content.status_id}`}>
                    {content.status_name || 'Unknown'}
                  </span>
                </div>
              </div>
              <div className="item-actions">
                <button className="btn-icon btn-edit" title="Edit">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </button>
                <button className="btn-icon btn-preview" title="Preview">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                <button
                  className="btn-icon btn-delete"
                  onClick={() => handleDelete(content.id)}
                  title="Delete"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContentManager;
